import type { DropPhase, MinimalDrop } from "@anaconda/core/drop/types"

export const checkIsPhaseActive = (phase: DropPhase) => {
  const now = new Date().getTime()
  const startDate = new Date(phase.startDate).getTime()
  const endDate = phase.endDate ? new Date(phase.endDate).getTime() : undefined
  return startDate <= now && (!endDate || now < endDate)
}

export function getDropCurrentPhase(phases: MinimalDrop["phases"]) {
  if (!phases || phases.length === 0) return null

  const activePhase = phases.find(checkIsPhaseActive)

  return activePhase || phases[0]
}
